<template>
    <f-dialog
        icon          = "mdi-information"
        :title        = "title"
        v-model       = "show"
        :width        = "600"
        :hide-actions = "true"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <div v-if="info" class="mt-2 mb-3">
                <v-row dense>
                    <v-col class="no-frame">
                        <f-read-only-field
                            label="Name"
                            :value="info.name"
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col class="no-frame pr-2">
                        <f-read-only-field
                            label="Besitzer"
                            :value="info.owner"
                        />
                    </v-col>
                    <v-col class="no-frame pr-2">
                        <f-read-only-field
                            label="Erstellt"
                            :value="format (info.created)"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <f-read-only-field
                            label="Letzte Änderung"
                            :value="format (info.modified)"
                        />
                    </v-col>
                </v-row>
                <v-row dense class="mt-4">
                    <v-col class="no-frame">
                        <f-read-only-field
                            label="Archiv"
                            :value="info.archive"
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col class="no-frame">
                        <div class="readonly-label primary--text" style="font-size: 11px;">
                            Referenzen
                        </div>
                        <div class="doc-pathname" v-for="(parent, index) in info.parents" :key="index">
                            {{ parent }}
                        </div>
                    </v-col>
                </v-row>
            </div>
        </template>
    </f-dialog>
</template>

<script>
import FDialog from "@/modules/core/components/utils/FDialog.vue";
import Dms from "@/modules/dms/common/service/Dms";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import Core from "@/modules/core/service/Core";
export default {
    name: "DIncDocumentInfo",
    components: {
        FReadOnlyField,
        FDialog
    },

    props: {
        value: {

        },

        document: {

        }
    },

    data: () => ({
        show: false,
        info: null
    }),

    computed: {
        title () {
            return "Dokument";
        }
    },

    mounted() {
        this.show = this.value;
        this.load();
    },

    watch: {
        value () {
            this.show = this.value;
            this.load();
        }
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        format (value) {
            console.log("format", value)
            if (!value) {
                return "---"
            }
            return Core.format.datetime.display(value);
        },

        load () {
            if (!this.document) {
                return;
            }

            Dms.info(this.document.id).then (info => {
                console.log(info)
                this.info = info;
            })

        }
    }
}
</script>

<style scoped>

.doc-pathname {
    font-size: 16px;
}

</style>